import CustomChip from '../shared/CustomChip';
import { formatDateTime } from './FormateDateTime';

export const sequenceTableTemplate = (rowData, options) => {
  return options.rowIndex + 1;
};

export const dateTempelate = data => {
  return formatDateTime(data?.visitDateTime);
};

export function getColor(status) {
  const statusMap = {
    complete: 'success',
    open: 'success',
    paid: 'success',
    active: 'success',
    confirmed: 'success',
    failed: 'danger',
    unpaid: 'danger',
    expired: 'danger',
    closed: 'danger',
    inactive: 'danger',
    pending: 'warning',
    approved: 'success',
    rejected: 'danger',
    cancelled: 'danger',
    compeleted: 'success',
    completed: 'success',
    upcoming: 'primary',
    Upcoming: 'primary',
    Cancelled: 'danger'
  };

  return statusMap[status?.toLowerCase()] || 'primary';
}

export const statusTemplate = (rowData, options) => {
  if (!rowData?.status) return '';
  return (
    <CustomChip
      label={rowData?.status}
      chipType={getColor(rowData?.status)}
      className='h-[22px] rounded-full px-2 py-1'
    />
  );
};
